import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  title: () => faker.lorem.words(2),
  requiredAttributes: () => [],
  deactivatable: true,
  sortable: true,
  editable: true,
});
